import { useMemo } from 'react'

import type { CSSProperties } from 'react'
import type { PaddingProps } from './Padding.props'

const Padding = ({ p, pt, pr, pb, pl, px, py, children, style, ...props }: PaddingProps) => {
  const PaddingStyles = useMemo(() => {
    const updatedStyles: CSSProperties = {}

    if (p) {
      updatedStyles.padding = p
    }

    if (pt) {
      updatedStyles.paddingTop = pt
    }
    if (pr) {
      updatedStyles.paddingRight = pr
    }
    if (pb) {
      updatedStyles.paddingBottom = pb
    }
    if (pl) {
      updatedStyles.paddingLeft = pl
    }

    if (px) {
      updatedStyles.paddingLeft = px
      updatedStyles.paddingRight = px
    }

    if (py) {
      updatedStyles.paddingTop = py
      updatedStyles.paddingBottom = py
    }

    return updatedStyles
  }, [p, pt, pr, pb, pl, px, py])

  return (
    <div style={{ ...style, ...PaddingStyles }} {...props}>
      {children}
    </div>
  )
}

export { Padding }
